/**
 * Hodnocení jídel — hvězdy 1–5 + nepovinný komentář.
 *
 * Widget se vykresluje v jídelníčku (foodMenuItem.latte) i v přehledu objednaných
 * jídel (foodOrderTable.latte). Oba jsou uvnitř snippetů, které se po uložení celé
 * překreslí, takže všechny handlery musí být delegované na document.
 *
 * Hvězdy jsou povinné, komentář ne — komentářová část se proto vykresluje až po
 * udělení hvězd a při ukládání se posílá spolu s aktuálním počtem hvězd.
 */
(function () {
    'use strict';

    function sendRating(widget, url, data) {
        if (widget.data('rating-busy')) {
            return;
        }
        widget.data('rating-busy', true);
        widget.addClass('is-busy');

        $.nette.ajax({
            url: url,
            type: 'POST',
            data: data || {}
        }).done(function (payload) {
            if (payload && payload.warning) {
                toastr.warning(payload.warning);
            }
            if (payload && payload.googleReview) {
                showGoogleReviewPrompt(payload.googleReview);
            }
        }).always(function () {
            // Widget po úspěchu zmizí i s daty (snippet se překreslí); odemykáme pro případ,
            // že server vrátil warning a v DOM zůstal původní prvek.
            widget.data('rating-busy', false);
            widget.removeClass('is-busy');
        });
    }

    /**
     * Nabidka napsat recenzi dodavatele na Googlu po serii dobrych hodnoceni.
     *
     * Modal se staví v JS, ne snippetem: vyzva nepatri k zadnemu radku jidelnicku
     * a server ji posila az v odpovedi na ulozene hodnoceni. Texty i odkaz prichazeji
     * hotove z payloadu — prekladac tu k dispozici neni.
     *
     * Vyssi z-index nez modal po prihlaseni: serii jde dokoncit i uvnitr nej a vyzva
     * by se jinak schovala pod nej.
     */
    function showGoogleReviewPrompt(data) {
        // Adresu zadava zakaznik a do sloupce se da dostat i importem nebo primym SQL,
        // takze se schema overuje jeste tady — `javascript:` v href tlacitka by bylo
        // spusteni ciziho kodu v session stravnika.
        if (!data.url || !/^https?:\/\//i.test(data.url) || $('#foodRatingGooglePrompt').length) {
            return;
        }

        var overlay = $('<div>', {
            id: 'foodRatingGooglePrompt',
            'class': 'food-rating-prompt-overlay food-rating-google-overlay'
        });
        var box = $('<div>', {
            'class': 'food-rating-prompt',
            role: 'dialog',
            'aria-modal': 'true'
        });

        box.append($('<h2>').text(data.title || ''));
        box.append($('<p>', { 'class': 'food-rating-prompt-lead' }).text(data.lead || ''));

        var actions = $('<div>', { 'class': 'food-rating-prompt-actions' });
        // Vlastni trida, ne .food-rating-prompt-close: ta ma globalni delegovany
        // handler, ktery POSTuje na data-href. Bez nej by jQuery poslalo POST na
        // aktualni stranku.
        actions.append(
            $('<button>', { type: 'button', 'class': 'food-rating-google-dismiss' })
                .text(data.later || '')
                .on('click', function () { overlay.remove(); })
        );
        // noopener/noreferrer: odkaz vede na cizi domenu zadanou zakaznikem.
        actions.append(
            $('<a>', {
                'class': 'food-rating-google-link',
                href: data.url,
                target: '_blank',
                rel: 'noopener noreferrer'
            })
                .text(data.confirm || '')
                .on('click', function () { overlay.remove(); })
        );

        box.append(actions);
        overlay.append(box);

        // Klik mimo okno vyzvu zavre, stejne jako „Ted ne".
        overlay.on('click', function (e) {
            if (e.target === this) {
                overlay.remove();
            }
        });

        $('body').append(overlay);
    }

    function currentComment(widget) {
        var input = widget.find('.food-rating-comment-input');
        return input.length ? input.val() : null;
    }

    /**
     * Strávník viděl upozornění, že provozovatel uvidí jeho jméno (data-author-notice
     * z šablony). Server podle toho rozhodne, jestli hodnocení uloží jako neanonymní —
     * bez příznaku vždy anonymně, ať se jméno neodkryje někomu, kdo upozornění neviděl.
     */
    function withAuthorNotice(widget, data) {
        if (String(widget.data('author-notice')) === '1') {
            data.authorNotice = 1;
        }
        return data;
    }

    $(document).on('click', '.food-rating-star', function (e) {
        e.preventDefault();
        var star = $(this);
        var widget = star.closest('.food-rating');
        var stars = parseInt(star.data('value'), 10);
        var data = { stars: stars };

        // Komentář se přenáší jen když už nějaký je — jinak by přepsání hvězd
        // vynulovalo dřív uložený text.
        var comment = currentComment(widget);
        if (comment !== null) {
            data.comment = comment;
        }

        sendRating(widget, widget.data('rate-href'), withAuthorNotice(widget, data));
    });

    $(document).on('click', '.food-rating-clear', function (e) {
        e.preventDefault();
        var widget = $(this).closest('.food-rating');
        sendRating(widget, widget.data('remove-href'), {});
    });

    $(document).on('click', '.food-rating-comment-toggle', function (e) {
        e.preventDefault();
        var widget = $(this).closest('.food-rating');
        var box = widget.find('.food-rating-comment');
        var hidden = box.prop('hidden');

        box.prop('hidden', !hidden);
        if (hidden) {
            box.find('.food-rating-comment-input').trigger('focus');
        }
    });

    $(document).on('click', '.food-rating-comment-save', function (e) {
        e.preventDefault();
        var widget = $(this).closest('.food-rating');
        var stars = parseInt(widget.data('stars'), 10);

        if (!stars) {
            return;
        }

        sendRating(widget, widget.data('rate-href'), withAuthorNotice(widget, {
            stars: stars,
            comment: currentComment(widget) || ''
        }));
    });

    // „Teď ne" v modálu po přihlášení — odloží výzvu na serveru a snippet se překreslí prázdný.
    $(document).on('click', '.food-rating-prompt-close', function (e) {
        e.preventDefault();
        var button = $(this);

        $.nette.ajax({
            url: button.data('href'),
            type: 'POST'
        });
    });

    // Náhled hodnocení při přejetí myší — čistě vizuální, nic neukládá.
    $(document).on('mouseenter', '.food-rating-star', function () {
        var star = $(this);
        var value = parseInt(star.data('value'), 10);

        star.closest('.food-rating-stars').find('.food-rating-star').each(function () {
            $(this).toggleClass('is-preview', parseInt($(this).data('value'), 10) <= value);
        });
    });

    $(document).on('mouseleave', '.food-rating-stars', function () {
        $(this).find('.food-rating-star').removeClass('is-preview');
    });
})();
